import axios from "axios";
import { Base_URL } from "../url";

export const getPendingLeaves = (orgId, token) =>
  axios.get(`${Base_URL}/Leave/GetPendingLeaves`, {
    params: { org_id: orgId },
    headers: { Authorization: `Bearer ${token}` }
  });

export const getPendingWFH = (orgId, token) =>
  axios.get(`${Base_URL}/Leave/getworkfromhomeleave`, {
    params: { org_id: orgId },
    headers: { Authorization: `Bearer ${token}` }
  });

export const approveLeave = (id, token) =>
  axios.post(`${Base_URL}/Leave/ConfirmLeave/${id}`, null, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const rejectLeave = (id, token) =>
  axios.post(`${Base_URL}/Leave/RejectLeave/id?id=${id}`, null, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const approveWFH = (id, token) =>
  axios.post(`${Base_URL}/Leave/ConfirmWFH/${id}`, null, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const rejectWFH = (id, token) =>
  axios.post(`${Base_URL}/Leave/RejectWFH/${id}`, null, {
    headers: { Authorization: `Bearer ${token}` }
  });